import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../../../../services/general/general.service';
import { ConceptValues } from '../../../../models/concept-values.model';
import { Concept } from '../../../../models/concept.model';
import { District } from '../../../../models/district.model';
import { Sectional } from '../../../../models/sectional.model';
import { City } from '../../../../models/City.model';
import { RegistrationService } from '../../../../services/registration/registration.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IglesiasService } from '../../../../services/iglesias/iglesias.service';
import { Church } from '../../../../models/church.model';
import { MatSnackBar, MatDialog } from '@angular/material';
import { AlertComponent } from '@asambleas-components/alert/alert.component';
import { LoaderComponent } from '@asambleas-components/loader/loader.component';
import { environment } from '@asambleas-env/environment';
import { LoginService } from '@asambleas-services/login/login.service';

@Component({
  selector: 'app-new-church',
  templateUrl: './new-church.component.html',
  styleUrls: ['./new-church.component.scss']
})
export class NewChurchComponent implements OnInit {
  churchTypes: ConceptValues;

  districts: District[];
  sectionals: Sectional[];
  cities: City[];

  districtSelected: District;

  church: Church = new Church();
  public previewImage: string; // PREVIEW IMAGE OR ORIGINAL IMAGE
  public imageFile: File; // IMAGE TO UPLOAD
  public canChangeImage: boolean = false;

  constructor(private _generalService: GeneralService,
    private registrationService: RegistrationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private _dialog: MatDialog,
    private _iglesiasService: IglesiasService,
    private loginService: LoginService) { }

  ngOnInit() {

    this.districts = [];
    this.sectionals = [];
    this.cities = [];
    this.canChangeImage = (this.loginService.getHighestRol() == 1);

    this.activatedRoute.params
      .subscribe((data) => {
        if (data.id) {
          this._iglesiasService.getChurch(data.id)
            .subscribe((data: Church) => {
              this.church = data;
              if (this.church.image_path) {
                this.previewImage = `${environment.apiEndPoint}/church-images/${this.church.image_path}`;
              }
              this.getDistritos(this.church.city.sectional.district.id);
            })
        }
        else {
          this.getDistritos();
        }
      })

    this.churchTypes = this._generalService.concepts[14];

    if (this.churchTypes == null) {
      this._generalService.getConceptDataById(14).subscribe((data: Concept) => {
        this.churchTypes = data.values
      })
    }

  }

  getDistritos(districtId: number = null) {
    this.registrationService.getDistricts().subscribe((districts: District[]) => {
      this.districts = districts;

      if (districtId) {

        this.filterSectionalsByDistrictId(this.church.city.sectional.district.id, this.church.city.sectional.id);
      }

    });
  }

  filterSectionalsByDistrictId(id: number, sectionalId: number = null) {

    this.sectionals = [];

    if (sectionalId == null) {
      this.church.city_id = null;
    }


    this.registrationService.getDistrictDataById(id)
      .subscribe((data: District) => {
        this.districtSelected = data;
        this.sectionals = data.sectionals;
        this.cities = [];

        if (sectionalId) {
          this.filterCitiesBySectionalId(sectionalId, 'edit');
        }

      })
  }

  filterCitiesBySectionalId(id: number, type: string = null) {
    if (type != 'edit') {
      this.church.city_id = null;
    }

    this.districtSelected.sectionals.forEach((sectional) => {
      if (sectional.id == id) {
        this.cities = sectional.cities;

      }
    })
  }

  update() {
    //console.log(this.church);

    this._iglesiasService.updateChurch(this.church)
      .subscribe((data) => {
        //console.log(data);
        this.snackBar.open('Iglesia modificada exitósamente', 'Cerrar', {
          duration: 3000
        });

        this.router.navigate(['/admin', 'iglesias', 'lista']);
      })
  }

  onFileChanged(event) {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    this.imageFile = file;

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      this.previewImage = reader.result.toString();
    };
  }

  uploadImage() {
    if (!this.imageFile) {
      return;
    }
    const loader = this._dialog.open(LoaderComponent);
    const uploadData = new FormData();
    uploadData.append("file", this.imageFile);
    uploadData.append('church_id', this.church.id.toString());
    this._generalService.uploadAvatarToChurch(uploadData)
      .subscribe((data: { message: 'string', path: 'string', user: any }) => {
        loader.close();
        this._dialog.open(AlertComponent, {
          width: '35vw',
          disableClose: true,
          data: {
            title: 'Felicitaciones',
            content: "Imagen de la iglesia cambiada exitosamente"
          }
        })
      }, (error) => {
        loader.close();
        console.log(error);
        this._dialog.open(AlertComponent, {
          width: '35vw',
          disableClose: true,
          data: {
            title: 'Lo sentimos',
            content: "Hubo un problema al intentar subir la imagen"
          }
        })
      })
  }

  changeImage() {
    this.imageFile = null;
    this.previewImage = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/iglesias/new-church/new-church.component.ts